import React from "react";

import { IconProps } from "fe-shared/src/types/common";

const MaterialIcon = ({
  width = "16",
  height = "16",
  style,
  className,
  fillClassName,
  fillColor = "#000",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 16 16"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M6.67 8c-.74 0-1.34.6-1.34 1.33a1.34 1.34 0 002.67 0C8 8.6 7.4 8 6.67 8zM4 5.33A1.34 1.34 0 004 8c.73 0 1.33-.6 1.33-1.33 0-.74-.6-1.34-1.33-1.34zm0 5.34c-.73 0-1.33.6-1.33 1.33 0 .73.6 1.33 1.33 1.33.73 0 1.33-.6 1.33-1.33 0-.73-.6-1.33-1.33-1.33zm8-5.34c.73 0 1.33-.6 1.33-1.33 0-.73-.6-1.33-1.33-1.33-.73 0-1.33.6-1.33 1.33 0 .73.6 1.33 1.33 1.33zm-2.67 5.34C8.6 10.67 8 11.27 8 12c0 .73.6 1.33 1.33 1.33.74 0 1.34-.6 1.34-1.33 0-.73-.6-1.33-1.34-1.33zM12 8c-.73 0-1.33.6-1.33 1.33 0 .74.6 1.34 1.33 1.34A1.34 1.34 0 0012 8zM9.33 5.33a1.34 1.34 0 000 2.67c.74 0 1.34-.6 1.34-1.33 0-.74-.6-1.34-1.34-1.34zM6.67 2.67c-.74 0-1.34.6-1.34 1.33A1.34 1.34 0 008 4c0-.73-.6-1.33-1.33-1.33z"
    />
  </svg>
);

export default MaterialIcon;
